import React from 'react';
import { Box, Typography, Card, Grid } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { COLORS } from '../../assets/colors';

const WelcomeCard = (props) => {
    const IconComponent = props.element.icon;


    return (
        <Grid item xs={12} sm={6} md={4} key={props.index} onClick={() => props.onClick(props.element.text)}>
            <Card
                sx={{
                    maxWidth: '100%',
                    height: '100%',
                    p: 1,
                    bgcolor: props.index === 5 ? COLORS.PINK_OPACITY : COLORS.WHITE_BLUE, // La 6ème carte a un bgcolor pink
                    cursor: 'pointer',
                    boxShadow: 'none',
                    '&:hover': {
                        bgcolor: props.index === 5 ? COLORS.PINK_OPACITY3 : COLORS.GRAY_HOVER, // Couleur de fond au survol
                        transition: 'background-color 0.4s ease', // Applique une transition sur la propriété background-color
                    },

                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <Box
                        sx={{
                            width: 48,
                            height: 48,
                            borderRadius: '50%',
                            bgcolor: props.index === 5 ? COLORS.PINK_OPACITY2 : COLORS.GRAY_AVATAR,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {React.cloneElement(IconComponent, {
                            sx: {
                                fontSize: 24,  // Taille de l'icône
                                color: props.index === 5 ? COLORS.PINK_INTELCIA : COLORS.GRAY_ICONS,  // Couleur dynamique
                            }
                        })}
                    </Box>

                    {/* Text content */}
                    <Typography
                        variant="body2"
                        component="h2"
                        sx={{
                            fontWeight: 'medium',
                            textAlign: 'left',
                            color: props.index === 5 ? COLORS.PINK_INTELCIA : COLORS.BLACK_TEXT
                        }}
                    >
                        {props.element.text}
                    </Typography>

                    <Box
                        sx={{
                            alignSelf: 'flex-start',
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            bgcolor: props.index === 5 ? COLORS.PINK_OPACITY2 : COLORS.GRAY_AVATAR,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >

                        <ArrowForwardIcon size={20} sx={{ color: props.index === 5 ? COLORS.PINK_INTELCIA : COLORS.BLACK_TEXT }}
                        />
                    </Box>
                </Box>
            </Card>
        </Grid >
    )
}

export default WelcomeCard;
